import { useEffect, useRef } from 'react';
import { cmpScriptElement, enableTrackingAndAnalytics } from '../../consentManager/tagHelpers';

function addItemwiseTracking(): void {
  const itemwiseScript = cmpScriptElement({ vendorID: 'c42595', async: true });
  itemwiseScript.textContent = `(function(i,s,o,g,r,a,m){i['TrackuityObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//the.itemwi.se/snippet.js','tty');
tty('auto', {key: '99Q8P9zuSnZrWHrX8Vr94d'});
tty('cookie-consent');`;
  document.head.append(itemwiseScript);
}

function addLinkedInTracking(): void {
  const linkedInScript1 = cmpScriptElement({ vendorID: 's2', async: true });
  linkedInScript1.textContent = `_linkedin_partner_id = "3732706";
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);`;
  document.head.append(linkedInScript1);

  const linkedInScript2 = cmpScriptElement({ vendorID: 's2', async: true });
  linkedInScript2.textContent = `(function(l) {
  if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
  window.lintrk.q=[]}
  var s = document.getElementsByTagName("script")[0];
  var b = document.createElement("script");
  b.type = 'text/javascript';b.async = true;
  b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
  s.parentNode.insertBefore(b, s);})(window.lintrk);`;
  document.head.append(linkedInScript2);
}

export default function WithTracking({ children }: { children: JSX.Element }): JSX.Element {
  const scriptsAdded = useRef(false);

  useEffect(() => {
    if (typeof document === 'undefined' || !enableTrackingAndAnalytics() || scriptsAdded.current) {
      return;
    }
    scriptsAdded.current = true;

    addItemwiseTracking();
    addLinkedInTracking();
  }, []);

  return children;
}
